import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../store';
import { useTranslation } from 'react-i18next';
import { IStepControl } from '../../../domains/wizard';
import { PricesReview } from './prices-review';
import { OnboardingReview } from './onboarding-review';
import { DelegatesReview } from './delegates-review';
import { ServiceAddressReview } from './service-address-review';
import { ShippingStepReview } from './shipping-step-review';
import { BillingStepReview } from './billing-step-review';
import { PaymentStepReview } from './payment-step-review';
import { TermsReview } from './terms-review';

interface IProps {
  stepControl: IStepControl;
}

const ReviewAndSignUp = observer((props: IProps) => {
  const { t } = useTranslation('', { keyPrefix: 'REVIEW_AND_SIGN_UP' });
  const { quoteStore } = useStore();

  return (
    <div className={'step'}>
      <h2>{t('TITLE')}</h2>
      <span className={'step-info dark'}>{t('INFO')}</span>

      <PricesReview />

      {quoteStore.isOnboardingStepAvailable && <OnboardingReview stepControl={props.stepControl} />}

      {quoteStore.isDelegateStepAvailable && <DelegatesReview stepControl={props.stepControl} />}

      {quoteStore.isServiceStepAvailable && <ServiceAddressReview stepControl={props.stepControl} />}

      {quoteStore.isShippingStepAvailable && <ShippingStepReview stepControl={props.stepControl} />}

      {quoteStore.isBillingStepAvailable && <BillingStepReview stepControl={props.stepControl} />}

      {quoteStore.isPaymentStepAvailable && <PaymentStepReview stepControl={props.stepControl} />}

      <TermsReview />
    </div>
  );
});

export default ReviewAndSignUp;
